<mat-card>
  <form name="bookingForm" [formGroup]="form">
    <h3>Booking information</h3>
    <p>If there is a booking system for the event, please fill in the details below.</p>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <mat-form-field appearance="outline">
          <input matInput formControlName="bookingWebsite" name="booking_website" aria-label="Booking Website" type="url" (focusout)="prepareUrl($event,'bookingWebsite')">
          <mat-label>Booking Website</mat-label>
          <mat-hint>Is there  a website for ticket sales?</mat-hint>
          <mat-error *ngIf="form.get('bookingWebsite').invalid">{{getErrorMessage('bookingWebsite')}}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12">
        <mat-form-field appearance="outline">
          <input matInput formControlName="bookingPhone" type="tel" (focusout)="trimValue($event,'bookingPhone','phone')" (focus)="prefillphone($event,'bookingPhone')">
          <mat-label>Booking Phone</mat-label>
          <mat-icon matSuffix>phone</mat-icon>
          <mat-hint>Is there a phone number people can call to book this event?</mat-hint>
          <mat-error *ngIf="form.get('bookingPhone').invalid">{{getErrorMessage('bookingPhone')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-card>